import React, { Component } from 'react';
import { ApolloSandbox } from '@apollo/sandbox/react';

class schema extends Component {
	render() {
		return (
			<div className="graphqlSchema">
				<ApolloSandbox />
			</div>
		);
	}
}

export default schema;
